import React from 'react';
import './workWithUs.css'
import {Container} from "react-bootstrap";
import CustomButton from "../accesories/customBtn/CustomButton";

function WorkWithUs({img,content=""}) {
    return (
        <Container fluid className={'work-with-us-container'}>
            <div className="parallax" style={{
                background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/static/images/work-with-us.jpg") center/cover no-repeat fixed`
            }}>
                <div className="parallax-content">
                    <h2><span>همکاری</span> با ما</h2>
                    <p>{content}</p>
                    <div>
                        <CustomButton href={'/about-us'} width={'11rem'} height={'3rem'} color={'#1D2E3D'} text={'مشاهده بیشتر...'}/>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default WorkWithUs;